var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import React from 'react';

import { useLoaderData } from 'react-router-dom';
import { createColumnHelper } from '@tanstack/react-table';
import { Translate } from "../../../../I18N";

import { Table } from "../../../Components/UI";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import * as translationsAPI from "../../../api/translations";
import {
  ContextPill,
  RenderButton,
  ActionHeader,
  LabelHeader,
  TypeHeader } from "./components/TableComponents";


const translationsListLoader =
(headers) =>
async () =>
translationsAPI.get(headers);

const TranslationsList = () => {var _translations$, _translations$$contex;
  const translations = useLoaderData();

  const contexts =


  { systemContexts: [], contentContexts: [] };

  (_translations$ = translations[0]) === null || _translations$ === void 0 ? void 0 : (_translations$$contex = _translations$.contexts) === null || _translations$$contex === void 0 ? void 0 : _translations$$contex.forEach((context) => {
    const contextTranslations = _objectSpread({}, context);

    if (!contextTranslations.values || Object.keys(contextTranslations.values).length === 0) {
      return undefined;
    }

    if (contextTranslations.type === 'Uwazi UI') {
      return contexts.systemContexts.push(_objectSpread({}, contextTranslations));
    }

    return contexts.contentContexts.push(_objectSpread({}, contextTranslations));
  });

  // Helper typed as any because of https://github.com/TanStack/table/issues/4224
  const columnHelper = createColumnHelper();
  const columns = [
  columnHelper.accessor('label', {
    header: LabelHeader,
    meta: { className: 'w-1/3' }
  }),
  columnHelper.accessor('type', {
    header: TypeHeader,
    cell: ContextPill,
    meta: { className: 'w-2/3' }
  }),
  columnHelper.accessor('id', {
    header: ActionHeader,
    cell: RenderButton,
    enableSorting: false,
    meta: { className: 'text-center w-0' }
  })];


  return /*#__PURE__*/(
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-translations" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Translations" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { "data-testid": "translations" }, void 0, /*#__PURE__*/
    _jsx(Table, {
      columns: columns,
      data: contexts.systemContexts,
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "System translations"),
      initialState: { sorting: [{ id: 'label', desc: false }] } }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "mt-4", "data-testid": "content" }, void 0, /*#__PURE__*/
    _jsx(Table, {
      columns: columns,
      data: contexts.contentContexts,
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Content translations"),
      initialState: { sorting: [{ id: 'label', desc: false }] } }
    )
    )
    )
    )
    ));

};

export { TranslationsList, translationsListLoader };